<div class="med-tab-group">
  <med-tab
    (click)="onActive(option)"
    [active]="compare(option.value)"
    *ngFor="let option of options"
    class="med-tab-group__item"
  >
    <ng-container *ngIf="tabTemplate; else tabTitle">
      <ng-container *ngTemplateOutlet="tabTemplate; context: { $implicit: option }"></ng-container>
    </ng-container>

    <ng-template #tabTitle> {{ option.label }} </ng-template>
  </med-tab>
</div>
